function customProduct(){
    $('.product').each(function() {
        var product = $(this);
        if ($(this).find('.flag-discount').length) {
            $(this).find('.flag-discount').contents().filter(function() {
                return this.nodeType === 3 && this.nodeValue.includes('od');
            }).each(function() {
                this.nodeValue = this.nodeValue.replace('od', '');
            });
            $(this).find('.prices').prepend($(this).find('.price-standard').clone());
        }
        $(this).find('.p').append('<span class="btn_toggle"></span>')
    });
}
    

$(document).ready(function(){
    customProduct();
});
    
document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    customProduct();
});
document.addEventListener('ShoptetPageSortingChanged', function() {
    customProduct();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    customProduct();
});